import { Grid, Typography } from "@mui/material";

import CoinSelectItem from "./Component/CoinSelectItem";
import DatePicker from "components/DatePicker";
import Select from "components/Select";
import { useForm } from "react-hook-form";
import { useSelector } from "react-redux";
import { useSearchParams } from "react-router-dom";

function FilterTransferHistory() {
  const [searchParams, setSearchParams] = useSearchParams();

  const historyFormData = useSelector(
    (state) => state.wallet?.spotTransferHistoryForm?.data
  );

  const defaultValues = {
    dateFrom: searchParams.get("dateFrom") || "",
    dateTo: searchParams.get("dateTo") || "",
    transferId: +searchParams.get("transferId") || 0,
    coinId: +searchParams.get("coinId") || -1,
  };

  const { watch, setValue } = useForm({ defaultValues });

  const handleChange = (value, fieldName) => {
    setValue(fieldName, value);
    const allSearchParams = Object.fromEntries([...searchParams]);

    setSearchParams({
      ...allSearchParams,
      page: 1,
      [fieldName]: value,
    });
  };


  return (
    <Grid container spacing={2} mb={2}>
      <Grid item md={4} xs={12}>
        <Typography variant="label" color="text.secondary">
          From Date
        </Typography>

        <DatePicker
          value={watch("dateFrom")}
          onChange={(e) => {
            handleChange(e, "dateFrom");
          }}
        />
      </Grid>

      <Grid item md={4} xs={12}>
        <Typography variant="label" color="text.secondary">
          To Date
        </Typography>

        <DatePicker
          value={watch("dateTo")}
          onChange={(e) => {
            handleChange(e, "dateTo");
          }}
        />
      </Grid>

      <Grid item md={4} xs={12}>
        <Typography variant="label" color="text.secondary">
          Coin
        </Typography>

        <Select
          items={historyFormData?.lisCoin}
          value={watch("coinId")}
          itemText="name"
          itemValue="id"
          onChange={(e) => {
            handleChange(e.target.value, "coinId");
          }}
          dir="ltr"
          customValue={(data) => <CoinSelectItem data={data} />}
        />
      </Grid>

      <Grid item md={4} xs={12}>
        <Typography variant="label" color="text.secondary">
          Change Transfer
        </Typography>

        <Select
          items={historyFormData?.lisTypeTransfer}
          value={watch("transferId")}
          onChange={(e) => {
            handleChange(e.target.value, "transferId");
          }}
          itemText="name"
          itemValue="id"
          dir="rtl"
        />
      </Grid>
    </Grid>
  );
}

export default FilterTransferHistory;
